import { connect } from "react-redux";
import mixpanel from "mixpanel-browser";
import * as Sentry from "@sentry/react";

import { signInWithEmailAndPassword, auth } from "_firebase";

import { actions as userActions } from "store/users";

import { authErrors } from "utils/firebase";
import { loginUserAPI } from "utils/auth/api";

import Login from "./";

const { fetchUserData, userStart, userFail, fetchUserCodeLib, fetchUserDir } = userActions;

const mapStateToProps = ({ user: { error } }) => ({
    error,
});

const mapDispatchToProps = (dispatch) => ({
    loginUser: async (event, loginForm) => {
        event.preventDefault();
        dispatch(userFail(authErrors("")));
        try {
            await signInWithEmailAndPassword(loginForm.email.value, loginForm.password.value);

            const idToken = await auth.currentUser.getIdToken();

            const { data } = await loginUserAPI({ idToken });

            const { user } = data;

            const { uid = "" } = user;

            const codeLibError = await dispatch(fetchUserCodeLib(uid));
            if (typeof codeLibError === "string") {
                throw new Error(codeLibError);
            }

            const dirError = await dispatch(fetchUserDir(uid));
            if (typeof dirError === "string") {
                throw new Error(dirError);
            }

            mixpanel.track("Log In");

            await dispatch(userStart());

            const userToReturn = await dispatch(fetchUserData(uid));

            if (typeof userToReturn === "string") {
                throw new Error(userToReturn);
            }

            if (userToReturn.registrationComplete === false) {
                localStorage.setItem("wasLoggedIn", "true");
                return { ...userToReturn, registrationIncomplete: true };
            }

            const { email, name, company, userMeta: { role, experienceLevel } = {} } = userToReturn;

            Sentry.setUser({
                name,
                email,
                company,
            });

            await mixpanel.people.set({
                $email: email,
                $name: name,
                Company: company,
                Role: role,
                "Expierience Level": experienceLevel,
            });
            mixpanel.identify(uid);

            localStorage.setItem("wasLoggedIn", "true");

            return userToReturn;
        } catch (error) {
            await auth.signOut();

            console.log("error inside loginUser", JSON.stringify(error.message));

            // await logoutUserAPI();

            return dispatch(userFail(authErrors(error)));
        }
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
